import { render, staticRenderFns } from "./ProviderCard.vue?vue&type=template&id=58503d62&scoped=true&"
import script from "./ProviderCard.vue?vue&type=script&lang=js&"
export * from "./ProviderCard.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCard.vue?vue&type=style&index=0&id=58503d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58503d62",
  null
  
)

component.options.__file = "ProviderCard.vue"
export default component.exports